import { CancelControllers } from '../../types/request.payload';

type PayloadId = {
  id: string;
};

type ReturnData<T> = {
  payload: T;
  signal: AbortController['signal'];
};

const addAbortRequest = <T>(
  func: (payload: T, signal: AbortController['signal']) => ReturnData<T>
) => {
  const cancelControllers: CancelControllers = {};

  return (payload: T extends PayloadId ? T : never) => {
    if (cancelControllers[payload.id]) {
      cancelControllers[payload.id].abort();
    }

    cancelControllers[payload.id] = new AbortController();
    const signal = cancelControllers[payload.id].signal;

    return func(payload, signal);
  };
};

export const getPayload = <T>(payload: T, signal: AbortController['signal']) => ({
  payload,
  signal,
});

export const getPayloadWithCancelSignal = addAbortRequest(getPayload);
